import React, { Fragment, useEffect } from "react";
import PageBannerComponent from "../Components/Common/PageBannerComponent";
import AuthLayout from "../Layout/AuthLayout";
import { useGetApplyJobMutation } from "../Store/api/DataApi";
import ApplicationItemComponent from "../Components/ManageApplication/ApplicationItemComponent";
import { useNavigate } from "react-router-dom";

export default function ManageApplications() {
  //let perPage = 10;
  //const [currentPage, setCurrentPage] = useState(1);
  const [getAplliedJobs, { data }] = useGetApplyJobMutation();
  const navigate = useNavigate();

  //   const bookmarkList = useCallback(
  //     (page, size = perPage) => {
  //       let params = {
  //         page: page,
  //         limit: size,
  //       };
  //       getAplliedJobs(params);
  //     },
  //     [perPage]
  //   );

  useEffect(() => {
    if (data?.error !== undefined && data?.error === "Invalid token!") {
      navigate("/logout");
    }
  }, [data, navigate]);

  useEffect(() => {
    getAplliedJobs(1);
  }, [getAplliedJobs]);
  return (
    <Fragment>
      <PageBannerComponent title="Manage Applications" />
      <AuthLayout>
        <div className="job-alerts-item">
          {data?.data?.length > 0 ? (
            (data?.data).map((job, i) => (
              <ApplicationItemComponent item={job} key={i} />
            ))
          ) : (
            <div className="row">
              <div className="col text-center h6">No Applications Found</div>
            </div>
          )}
          {/* <div className="applications-content">
            <div className="row">
              <div className="col-md-5">
                <div className="thums">
                  <img src={require('../Assets/img/post.png')} alt="" className="img-fluid" />
                </div>
                <h3>Web Designer Meeded</h3>
                <span>Quick Studio</span>
              </div>
              <div className="col-md-3">
                <p>
                  <span className="full-time">Full-Time</span>
                </p>
              </div>
              <div className="col-md-2">
                <p>Nov 14th, 2017</p>
              </div>
              <div className="col-md-2">
                <p>Rejected</p>
              </div>
            </div>
          </div>
          <div className="applications-content">
            <div className="row">
              <div className="col-md-5">
                <div className="thums">
                  <img src={require('../Assets/img/post.png')} alt="" className="img-fluid" />
                </div>
                <h3>Front-end developer needed</h3>
                <span>Quick Studio</span>
              </div>
              <div className="col-md-3">
                <p>
                  <span className="full-time">Full-Time</span>
                </p>
              </div>
              <div className="col-md-2">
                <p>Nov 14th, 2017</p>
              </div>
              <div className="col-md-2">
                <p>Processed</p>
              </div>
            </div>
          </div>
          <div className="applications-content">
            <div className="row">
              <div className="col-md-5">
                <div className="thums">
                  <img src={require('../Assets/img/post.png')} alt="" className="img-fluid" />
                </div>
                <h3>We're looking for an Art Director</h3>
                <span>Quick Studio</span>
              </div>
              <div className="col-md-3">
                <p>
                  <span className="part-time">Part-Time</span>
                </p>
              </div>
              <div className="col-md-2">
                <p>Nov 14th, 2017</p>
              </div>
              <div className="col-md-2">
                <p>Rejected</p>
              </div>
            </div>
          </div>
          <div className="applications-content">
            <div className="row">
              <div className="col-md-5">
                <div className="thums">
                  <img src={require('../Assets/img/post.png')} alt="" className="img-fluid" />
                </div>
                <h3>Web designer needed</h3>
                <span>Quick Studio</span>
              </div>
              <div className="col-md-3">
                <p>
                  <span className="full-time">Full-Time</span>
                </p>
              </div>
              <div className="col-md-2">
                <p>Nov 14th, 2017</p>
              </div>
              <div className="col-md-2">
                <p>Approved</p>
              </div>
            </div>
          </div>
          <div className="applications-content">
            <div className="row">
              <div className="col-md-5">
                <div className="thums">
                  <img src={require('../Assets/img/post.png')} alt="" className="img-fluid" />
                </div>
                <h3>Looking for a Project Leader</h3>
                <span>Quick Studio</span>
              </div>
              <div className="col-md-3">
                <p>
                  <span className="full-time">Full-Time</span>
                </p>
              </div>
              <div className="col-md-2">
                <p>Nov 14th, 2017</p>
              </div>
              <div className="col-md-2">
                <p>Rejected</p>
              </div>
            </div>
          </div>
          <div className="applications-content">
            <div className="row">
              <div className="col-md-5">
                <div className="thums">
                  <img src={require('../Assets/img/post.png')} alt="" className="img-fluid" />
                </div>
                <h3>We're hiring an fullstack designer</h3>
                <span>Quick Studio</span>
              </div>
              <div className="col-md-3">
                <p>
                  <span className="part-time">Part-Time</span>
                </p>
              </div>
              <div className="col-md-2">
                <p>Nov 14th, 2017</p>
              </div>
              <div className="col-md-2">
                <p>Rejected</p>
              </div>
            </div>
          </div> */}
          {/* Start Pagination */}
          {/* <br />
          <ul className="pagination">
            <li className="active">
              <Link to="" className="btn btn-common">
                <i className="ti-angle-left" /> prev
              </Link>
            </li>
            <li>
              <Link to="">1</Link>
            </li>
            <li>
              <Link to="">2</Link>
            </li>
            <li>
              <Link to="">3</Link>
            </li>
            <li>
              <Link to="">4</Link>
            </li>
            <li>
              <Link to="">5</Link>
            </li>
            <li className="active">
              <Link to="" className="btn btn-common">
                Next <i className="ti-angle-right" />
              </Link>
            </li>
          </ul> */}
          {/* End Pagination */}
        </div>
      </AuthLayout>
    </Fragment>
  );
}
